export const MORSE_TABLE_PRETTY = [
  "A  · —      N  — ·",
  "B  — · · ·  O  — — —",
  "C  — · — ·  P  · — — ·",
  "D  — · ·    Q  — — · —",
  "E  ·        R  · — ·",
  "F  · · — ·  S  · · ·",
  "G  — — ·    T  —",
  "H  · · · ·  U  · · —",
  "I  · ·      V  · · · —",
  "J  · — — —  W  · — —",
  "K  — · —    X  — · · —",
  "L  · — · ·  Y  — · — —",
  "M  — —      Z  — — · ·",
].join("\n");